
import WithoutSheetDetailForm from "./WithoutSheetDetailForm"; 




export default function Filters({ isOpen, setFiltersIsOpen }) {



  return <WithoutSheetDetailForm isOpen={isOpen} setFiltersIsOpen={setFiltersIsOpen} />;

}
